import { Link } from "react-router-dom";
import { motion } from "framer-motion";
export default function WillsEstate() {
  return (
     <motion.div
      className="max-w-4xl mx-auto px-6 py-12 text-center"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
    
    
      <h1 className="text-3xl md:text-4xl font-bold mb-6">Wills and Estate</h1>
      <p className="text-lg text-gray-700 leading-relaxed mb-8 text-left">
We help you plan for the future with clarity, care, and confidence. Whether you are drafting a will, a power of attorney, or a personal directive, our goal is to ensure your wishes are clearly expressed and legally protected. We take the time to understand your unique personal and family circumstances, so we can provide tailored legal advice that aligns with your values and priorities.
We also assist executors, trustees, and families with probate applications and estate administration. From obtaining grants of probate or administration to distributing estate assets, we provide step-by-step support to reduce stress and ensure compliance with legal requirements.
Whether you are planning ahead or navigating the responsibilities of an estate after the loss of a loved one, we are here to offer compassionate, knowledgeable, and practical guidance every step of the way.

      </p>
      <Link
        to="/contact"
        className="inline-block px-6 py-3 rounded-lg bg-blue-900 text-white font-semibold shadow hover:bg-blue-800 transition"
      >
        Request Consultation
      </Link>
     </motion.div>
  );
}
